import React, { Component } from "react";
import { withTranslation } from "react-i18next";

import styled from "styled-components";
import Faq from "./Faq";

const Wrapper = styled.div`
background-color: ${props => props.background ? `${props.background}` : ' #eaeaea' };
`

const Container = styled.div`
  margin: 0 auto;
  width: 930px;
  padding: 23px 0 24px 0;

  // Mobile version.
  @media (max-width: 768px) {
    padding: 23px 16px 24px 16px;
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  h2 {
    font-family: Lato-Light;
    font-size: 24px;
    color: #2b2b2b;
    line-height: 28px;
    margin: 0 0 10px 0;
  }
`;

class Faqs extends Component {

  componentDidMount(){
    document.title = this.props.t('Header.Title') + " " + this.props.t('Navigation.StockAwardLabel')
    document.getElementById('main-h1').innerHTML = this.props.t('Header.Title') + " " + this.props.t('Navigation.FAQLabel')
  }

  render() {
    const { t, faqs } = this.props;
    const hasFeaturedFaqs = faqs.length > 0

    if (!hasFeaturedFaqs) {
      return null
    }

    return (
      <Wrapper>
        <Container background={this.props.background}>
          <section className="faq-information-container" aria-labelledby="faqHeading">
            <h2 id="faqHeading">{t("HelpfulInformation.FAQTitle")}</h2>
            <Faq faqs={faqs}/>
          </section>
        </Container>
      </Wrapper>
    )
  }
}
 
export default withTranslation('translations')(Faqs);
